"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'GlPort',
  props: {
    value: {
      type: [String, Array],
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    displayInit: {
      type: [String, Array],
      default: null
    },
    placeholder: {
      type: String,
      default: function _default() {
        // return this.$t('associate.placeholder')
        return null;
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      columns: [{
        title: this.$t('home.route'),
        field: 'serviceLineCode',
        width: '200px'
      }]
    };
  },
  created: function created() {},
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  methods: {
    queryMethod: function queryMethod(_ref) {
      var keyword = _ref.keyword,
        pageSize = _ref.pageSize,
        currentPage = _ref.currentPage;
      var data = {};
      data.currentPage = currentPage;
      data.pageSize = pageSize;
      if (keyword !== '') {
        data.serviceLineCode = keyword;
      }
      if (data.serviceLineCode) {
        data.serviceLineCode = '%' + data.serviceLineCode + '%';
      }
      return new Promise(function (resolve, reject) {
        (0, _booking.queryListRoute)(data).then(function (res) {
          resolve({
            records: res.data.records,
            total: res.data.totalRecord,
            recordStart: res.data.recordStart,
            recordEnd: res.data.recordEnd
          });
        });
      });
    },
    change: function change(val, selectedRows) {
      //debugger
      this.$emit('input', val);
      this.$emit('change', val, selectedRows, this.index);
    },
    focus: function focus() {
      this.$emit('focus');
    },
    blur: function blur() {
      this.$emit('blur');
    },
    visibleChange: function visibleChange(visible) {
      this.$emit('visible-change', visible);
    } // displayFormat(record) {
    //   return `${record.vesselNameEn}(${record.vesselNameCn})`
    // }
  }
};